import React from 'react';

const VIA = "via";
const ViaTypes = {
    TV: "tv",
    DEFAULT: "default"
};

class SessionHelper {

    static saveVia(query){
        var via = query.via
        if (via) {
            via = via.toLowerCase();
        }else {
            via = ViaTypes.DEFAULT;
        }
        sessionStorage.setItem(VIA, via);
    }

    static getVia(){
        return sessionStorage.getItem(VIA);
    }

    static isViaTV(){
        var via = this.getVia();
        return (via == ViaTypes.TV);
    }

    static isViaEmpty(){
        var via = this.getVia();
        return (via == null);
    }
}

export default SessionHelper;


// WEBPACK FOOTER //
// ./helpers/session.helper.js